
export default [
			[
				{ sName: "Ryan", sAge: 35, sGender: 0, className: "现代舞少儿", classTotalFee: 500, settings: "" },
				{ className: "法语绘画", classTotalFee: 3500 },
			],
			[
				{
					sName: "Billy", sAge: 23, sGender: 0, className: "麻将高手", classTotalFee: 1000, settings: ""
				},
				{
					className: "吃饭绝招儿", classTotalFee: 350
				},
			],
			[
				{
					sName: "April", sAge: 22, sGender: 1, className: "韩式料理", classTotalFee: 8500, settings: ""
				},
			],
			[
				{
					sName: "Nick", sAge: 22, sGender: 0, className: "墨西哥舞",  classTotalFee: 8500, settings: ""
				},
			],
		];

		let defaultFields = [
			{ title: "班级名称", name: "a" },
			{ title: "日期", name: "b" },
			{ title: "上课进度", name: "c" },
			{ title: "老师", name: "d" },
			{ title: "学员", name: "e" },
		]

		let defaultData = [
			{ a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人", },
			{ a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人", },
			{ a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人", },
			{ a: "狂吃韩国料理", b: "2018 3月15日", c: "15/25", d: "金正恩", e: "352万人", },
		]



// WEBPACK FOOTER //
// ./src/containers/pages/UILibrary/example/data.js